// Angular imports
import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';

// Import components
import { CurrencyInputComponent } from '../../components'

// Modal system imports
import { BaseModalComponent } from '../../modal/base-modal';
import { ModalService } from '../../modal/modal.service';

// Import services
import { DataService } from '../../services/data.service';
import { ApplicationDataService } from '../../services/application-data.service';

// Import types
import { HourlyRate } from '../../types/value-set';
import { Project } from '../../types/project';
import { CalculationHeaderApi, CalculationMetaApi } from 'src/app/types';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/state-management/app-state';
import * as CalculationActions from 'src/app/state-management/calculation-actions';
import * as HeaderActions from 'src/app/state-management/actions/header-line-actions';

// Define types
export type EditHourlyRateModalArgs = {
    hourlyRate: CalculationHeaderApi;
    meta: CalculationMetaApi
}

@Component({
    selector: 'edit-hourly-rate-modal',
    templateUrl: './edit-hourly-rate-modal.component.html',
    styleUrls: ['./edit-hourly-rate-modal.component.scss'],
    standalone: false
})
export class EditHourlyRateModalComponent extends BaseModalComponent {
    // Title for modal service
    public title = 'Uurloon aanpassen';

    @ViewChild(CurrencyInputComponent) public _amountInput: CurrencyInputComponent;

    public _description: string = '';
    public _amount: number = 0;
    public meta: CalculationMetaApi = undefined;

    private hourlyRate: CalculationHeaderApi;

    constructor(
        private modalService: ModalService,
        private store: Store<AppState>
    ) {
        super();
    }

    public init(args: EditHourlyRateModalArgs) {
        this.hourlyRate = args.hourlyRate;
        this.meta = args.meta;

        this._description = this.hourlyRate.description;
        this._amount = this.hourlyRate.value;
    }

    public done() {
        // Close the modal
        this.modalService.close();

        this.update();
    }

    public updateDescription(value: string) {
        this._description = value;
        this.hourlyRate.description = this._description;

        // this.dataService.updateHourlyRate(this.applicationDataService.activeProject, this.applicationDataService.activeCalculation, this.hourlyRate);
    }

    public updateAmount(value: number) {
        this._amount = value;
        this.hourlyRate.value = value;

        // // Update hourly rate remote
        // this.dataService.updateHourlyRate(this.applicationDataService.activeProject, this.applicationDataService.activeCalculation, this.hourlyRate);

        // // Trigger recalculation
        // this.applicationDataService.triggerRecalculation();

        // TODO: Warnings
    }

    private update(){
        this.store.dispatch(HeaderActions.updateHeaderLine({
            projectId: this.meta.projectId,
            calculationId: this.meta.id,
            line: this.hourlyRate
        }))
    }

    /* --- Event handlers --- */

    public _handleFocusAmount(): void {
        // Select content
        this._amountInput.select();
    }
}
